import { IAuthModule } from "@/store/auth/IAuthModule";
import { IAuthState } from "@/store/auth/IAuthState";
import { Commit } from "vuex";
import { LoginResponse } from "@/services/apiClient";

const STORAGE_KEY = process.env.VUE_APP_STORE_KEY;

const defaultValues: IAuthState = {
  token: "",
  refreshToken: "",
  roleCode: "",
  username: "",
  userKey: "",
  userId: 0,
  wsToken: "",
};

export const authModule: IAuthModule = {
  namespaced: true,
  state: {
    ...defaultValues,
    ...JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}").auth,
  },
  getters: {
    token: (state: IAuthState): string => state.token,
    refreshToken: (state: IAuthState): string => state.refreshToken,
    roleCode: (state: IAuthState): string => state.roleCode,
    username: (state: IAuthState): string => state.username,
    userKey: (state: IAuthState): string => state.userKey,
    userId: (state: IAuthState): number => state.userId,
    wsToken: (state: IAuthState): string => state.wsToken,
  },
  mutations: {
    setToken: (state: IAuthState, payload: string): void => {
      state.token = payload;
    },
    setRefreshToken: (state: IAuthState, payload: string): void => {
      state.refreshToken = payload;
    },
    setRoleCode: (state: IAuthState, payload: string): void => {
      state.roleCode = payload;
    },
    setUsername: (state: IAuthState, payload: string): void => {
      state.username = payload;
    },
    setUserKey: (state: IAuthState, payload: string): void => {
      state.userKey = payload;
    },
    setUserId: (state: IAuthState, payload: number): void => {
      state.userId = payload;
    },
    setWsToken: (state: IAuthState, payload: string): void => {
      state.wsToken = payload;
    },
    logout: (state: IAuthState): void => {
      state.token = defaultValues.token;
      state.refreshToken = defaultValues.refreshToken;
      state.roleCode = defaultValues.roleCode;
      state.username = defaultValues.username;
      state.userKey = defaultValues.userKey;
      state.userId = defaultValues.userId;
      state.wsToken = defaultValues.wsToken;
    },
  },
  actions: {
    logout: ({ commit }: { commit: Commit }) => {
      commit("logout");
    },
    setLoginInformation: (
      { commit }: { commit: Commit },
      loginInfos: LoginResponse
    ) => {
      commit("setToken", loginInfos.token);
      commit("setRefreshToken", loginInfos.refreshToken);
      commit("setRoleCode", loginInfos.roleCode);
      commit("setUsername", loginInfos.username);
      commit("setUserId", loginInfos.userId);
      commit("setWsToken", loginInfos.wsToken);
    },
  },
};

export default authModule;
